import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { map, forEach } from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { TextInput } from '../utils/forms/TextInput';
import { Button } from '../utils/forms/Button';
import { Submit } from '../Formik/Submit';
import SelectField from '../Formik/SelectField';

function ParkingSpotForm({ handleCancel, initialValues, handleSubmit }) {
  const lotsOptions = useSelector((state) =>
    map(state.lots, (lot) => ({ label: lot.name, value: lot.id }))
  );

  const userOptions = useSelector((state) =>
    map(state.users, (user) => ({
      label: `${user.firstName} ${user.lastName}`,
      value: user.id
    }))
  );

  userOptions.push({ label: '', value: '' });

  const validationSchema = Yup.object().shape({
    lot: Yup.number().required('Musíte vybrat parkoviště'),
    floor: Yup.number().required('Patro je povinné'),
    place: Yup.string().required('Název místa je povinné')
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      handleCancel={handleCancel}
      validationSchema={validationSchema}
      enableReinitialize
    >
      <Form>
        <div>
          <SelectField
            name="lot"
            label="Vyberte parkoviště"
            options={lotsOptions}
          />
        </div>
        <div className="mt2">
          <Field
            name="place"
            label="Č. parkovacího místa"
            component={TextInput}
          />
        </div>
        <div className="mt2">
          <Field name="floor" label="Patro" component={TextInput} />
        </div>
        <div>
          <SelectField
            name="owner"
            label="Majitel místa"
            options={userOptions}
            searchable
          />
        </div>
        <div className="center mt2 mxn1">
          <span className="mr1">
            <Button type="button" color="secondary" onClick={handleCancel}>
              Zrušit
            </Button>
          </span>
          <span className="ml1">
            <Submit value={initialValues.place === '' ? 'Přidat' : 'Upravit'} />
          </span>
        </div>
      </Form>
    </Formik>
  );
}

ParkingSpotForm.propTypes = {
  initialValues: PropTypes.shape({
    lot: PropTypes.string,
    floor: PropTypes.string,
    place: PropTypes.string,
    owner: PropTypes.string
  })
};

ParkingSpotForm.defaultProps = {
  initialValues: {
    lot: '',
    floor: '',
    place: '',
    owner: null
  }
};

export default ParkingSpotForm;
